import React from "react";
import OpcionDefecto from '../../../../../Common/Components/OpcionDefecto';
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";

const ComercializadoresCanalesHabilitados = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN, GET_PARAMETRO_GENERAL } = data;

    let flagSinCanal = false;

    if (GET_PARAMETRO_GENERAL == null || GET_PARAMETRO_GENERAL == undefined) {
        return null;
    }

    if (GET_PARAMETRO_GENERAL.SINOCOMERCIALIZADORA == true) {
        let arrayAux = GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN.filter(d => d.Checked);

        if (arrayAux.length > 0) {

            let arrayMapped = [];

            arrayAux.forEach(function (comercializadora) {

                var canalesVta = comercializadora.CanalVentas.filter(e => e.Checked);

                if (canalesVta.length > 0) {

                    canalesVta.forEach(function (canalVta) {

                        arrayMapped.push({ Checked: true, Id: (comercializadora.Id + "-" + canalVta.Id), Descripcion: (comercializadora.Descripcion + " - " + canalVta.Descripcion) });
                    })

                } else {
                    if(comercializadora.CanalVentas.length==0){
                        arrayMapped.push({ Id: comercializadora.Id, Descripcion: comercializadora.Descripcion, conSubcanales:false });    
                    }else{
                        arrayMapped.push({ Id: comercializadora.Id, Descripcion: comercializadora.Descripcion, conSubcanales:true });
                    }
                }

            })

            arrayAux = arrayMapped;
        }

        GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN.forEach(comercializadora=>{
            if(comercializadora.Checked){
                flagSinCanal = !comercializadora.CanalVentas.some(canal=>canal.Checked)
            }
        })

        return (
            <div className="row">
                <div className="col-xs-12 top-separator-xxs">
                    <label className="label-primary">{"Comercializadora y Canales Habilitados"}</label>
                </div>
                <div className="col-xs-12">
                    <CheckDefecto
                        nombre={"Habilitar Comercializadora"}
                        check={data.HabilitaComercializadora}
                        referencia={"HACOMER"}
                        selectCheckBox={(event) => selectCheckBox("HabilitaComercializadora", event.target.checked)}
                    />
                </div>
                {data.HabilitaComercializadora && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                    {GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN.map( ( item ) => {
                        const referencia = `GCCVBA-${item.Id}`;
                        
                        return (
                            item.CanalVentas.length>0 && <CheckDefecto
                                key={item.Id}
                                nombre={item.Descripcion}
                                check={item.Checked}
                                activo={item.Activo}
                                referencia={referencia}
                                selectCheckBox={() => {
                                    if ( data.HabilitaComercializadora ) {
                                        selectCheckBox( "GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN", item.Id );
                                    }
                                }}
                            >
                                <div className="left-separator-xs">
                                    {item.CanalVentas.filter( cV => cV.RelacionId ).map( subitem => {
                                        const subItemRef = `SIGCCVBA-${item.Id}-${subitem.Id}`;

                                        return (
                                            <CheckDefecto
                                                key={subitem.Id}
                                                nombre={subitem.Descripcion}
                                                check={subitem.Checked}
                                                activo={subitem.Activo}
                                                referencia={subItemRef}
                                                selectCheckBox={() => {
                                                    if ( data.HabilitaComercializadora ) {
                                                        selectCheckBox( "GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN", item.Id, subitem.Id );
                                                    }
                                                }}
                                            />
                                        )
                                    } )}
                                </div>
                            </CheckDefecto>
                        )
                    } )}
                </div>}
                <div className="col-xs-12">
                    {(data.HabilitaComercializadora && !data.ERROR_PRODUCT["seleccionoComercializadora"] && ((arrayAux.length===0)))
                        && <label className="error">{"Debe seleccionar al menos una comercializadora"}</label>}
                </div>
                <div className="col-xs-12">
                    {(data.HabilitaComercializadora && !data.ERROR_PRODUCT["seleccionoComercializadora"] && flagSinCanal)
                        && <label className="error">{"Debe seleccionar al menos un canal de venta"}</label>}
                </div>
                <div className="col-xs-12">
                    {data.HabilitaComercializadora &&<OpcionDefecto
                        selecciono={arrayAux.length}
                        infoData={arrayAux.filter(comCanalVenta=>isNaN(comCanalVenta.Id))}
                        referencia={"ComercializadoraCanalDefaultIdFront"}
                        valorCombo={data.ComercializadoraCanalDefaultIdFront}
                        valorChecked={data.ComercializadoraCanalDefaultInterfaz}
                        selectCombo={(value) => selectCombo("ComercializadoraCanalDefaultIdFront", value)}
                        selectCheckBox={(value) => selectCheckBox("ComercializadoraCanalDefaultInterfaz", value)}
                    />}
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default ComercializadoresCanalesHabilitados;